<div class="row">
    <div class="col-sm-6 col-md-4 col-lg-3">
        <app-tab-dashboard-reductions-left-side></app-tab-dashboard-reductions-left-side>
    </div>
    <div class="col-sm-6 col-md-8 col-lg-9">
        <app-tab-dashboard-reductions-right-side></app-tab-dashboard-reductions-right-side>
    </div>
</div>